/**
 * Aveline — product.js
 * Variant selection, quantity controls, sticky ATC bar, related products.
 * No external libraries.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  /* --- Variant selection ------------------------------------------------ */

  var variantsScript = root.querySelector('[data-variants-json]');
  var variants = [];
  if (variantsScript) {
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      variants = [];
    }
  }

  var picker = root.querySelector('[data-variant-picker]');
  var variantInput = root.querySelector('[data-variant-input]');
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare-price]');
  var atcButton = root.querySelector('[data-atc-button]');
  var atcText = root.querySelector('[data-atc-text]');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  var stickyButton = root.querySelector('[data-sticky-button]');

  function scrollMediaIntoGallery(media) {
    if (!media) return;
    var track = media.closest('[data-gallery-track]');
    if (!track) return;

    var centeredLeft = media.offsetLeft - (track.clientWidth - media.clientWidth) / 2;
    var maxLeft = Math.max(0, track.scrollWidth - track.clientWidth);
    track.scrollTo({
      left: Math.min(Math.max(0, centeredLeft), maxLeft),
      behavior: 'smooth'
    });
  }

  function selectedOptions() {
    var options = [];
    root.querySelectorAll('[data-option-position]').forEach(function (fieldset) {
      var checked = fieldset.querySelector('input:checked');
      options[Number(fieldset.getAttribute('data-option-position')) - 1] = checked ? checked.value : null;
    });
    return options;
  }

  function findVariant(options) {
    return variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === options[index];
      });
    });
  }

  function updateVariant() {
    var variant = findVariant(selectedOptions());

    if (!variant) {
      if (atcButton) {
        atcButton.disabled = true;
        if (atcText) atcText.textContent = atcButton.getAttribute('data-text-unavailable');
      }
      if (stickyButton) stickyButton.disabled = true;
      return;
    }

    if (variantInput) variantInput.value = variant.id;

    if (priceEl) {
      priceEl.innerHTML = variant.price_html;
      priceEl.classList.toggle('product__price-current--sale', Boolean(variant.compare_html));
    }
    if (compareEl) {
      if (variant.compare_html) {
        compareEl.innerHTML = variant.compare_html;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (stickyPrice) stickyPrice.innerHTML = variant.price_html;

    if (atcButton) {
      atcButton.disabled = !variant.available;
      if (atcText) {
        atcText.textContent = variant.available
          ? atcButton.getAttribute('data-text-add')
          : atcButton.getAttribute('data-text-sold-out');
      }
    }
    if (stickyButton) stickyButton.disabled = !variant.available;

    // Keep the URL shareable for the selected variant.
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    // Jump the gallery to the variant image when it has one.
    if (variant.featured_media_id) {
      var media = root.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
      scrollMediaIntoGallery(media);
    }
  }

  if (picker) {
    picker.addEventListener('change', function (event) {
      if (event.target.matches('[data-option-input]')) updateVariant();
    });
  }

  /* --- Quantity controls -------------------------------------------------- */

  var quantityInput = root.querySelector('[data-quantity-input]');
  if (quantityInput) {
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-quantity-decrease]')) {
        quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
      }
      if (event.target.closest('[data-quantity-increase]')) {
        quantityInput.value = Number(quantityInput.value || 1) + 1;
      }
    });
  }

  /* --- Sticky mobile add-to-cart bar ------------------------------------------ */

  var stickyBar = root.querySelector('[data-sticky-atc]');
  var buyBlock = root.querySelector('[data-buy-block]');
  if (stickyBar && buyBlock && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
      },
      { threshold: 0 }
    );
    observer.observe(buyBlock);
  }

  /* --- Related products (Product Recommendations API) --------------------------- */

  var related = document.querySelector('[data-related-products]');
  function loadRelatedProducts() {
    if (!related || !related.getAttribute('data-url') || related.getAttribute('data-loaded') === 'true') return;
    related.setAttribute('data-loaded', 'true');

    fetch(related.getAttribute('data-url'))
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-related-products]');
        if (fresh && fresh.innerHTML.trim().length) {
          related.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {
        /* Recommendations are an enhancement; fail silently. */
      });
  }

  if (related && related.getAttribute('data-url')) {
    if ('IntersectionObserver' in window) {
      var relatedObserver = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            relatedObserver.disconnect();
            loadRelatedProducts();
          }
        },
        { rootMargin: '400px 0px' }
      );
      relatedObserver.observe(related);
    } else {
      loadRelatedProducts();
    }
  }

  /* --- Media gallery thumbnails ------------------------------------------- */

  var gallery = root.querySelector('[data-gallery]');
  if (gallery) {
    var galleryTrack = gallery.querySelector('[data-gallery-track]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var slides = galleryTrack
      ? Array.prototype.slice.call(galleryTrack.querySelectorAll('[data-gallery-slide]'))
      : [];

    function setActiveThumb(index) {
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle(
          'is-active',
          Number(thumb.getAttribute('data-gallery-thumb')) === index
        );
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = Number(thumb.getAttribute('data-gallery-thumb'));
        var slide = slides[index];
        if (slide) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        setActiveThumb(index);
      });
    });

    if (slides.length && 'IntersectionObserver' in window) {
      var galleryObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              var idx = slides.indexOf(entry.target);
              if (idx !== -1) setActiveThumb(idx);
            }
          });
        },
        { root: galleryTrack, threshold: [0.6] }
      );
      slides.forEach(function (slide) {
        galleryObserver.observe(slide);
      });
    }
  }
})();

/* Bundle deal: radio selection drives the quantity input */
(function () {
  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  var options = root.querySelectorAll('[data-bundle-option]');
  if (!options.length) return;

  var quantityInput = root.querySelector('[data-quantity-input]');

  function apply() {
    var checked = root.querySelector('[data-bundle-option]:checked');
    if (!checked || !quantityInput) return;
    quantityInput.value = checked.value;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  options.forEach(function (option) {
    option.addEventListener('change', apply);
  });

  apply();
})();

/* Combo deal: add-on variant dropdown keeps its radio and prices in sync.
   Separate IIFE — the bundle module above bails out when no bundle block is present. */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  /* --- Combo deal ------------------------------------------------------------
     Changing an add-on's variant dropdown updates that option's radio value and
     its displayed prices, and selects the option so the choice can't be lost.
     Prices are pre-rendered by Liquid onto each <option>, so there is no money
     formatting in JS. */

  root.querySelectorAll('[data-combo]').forEach(function (combo) {
    combo.addEventListener('change', function (event) {
      var select = event.target.closest('[data-combo-variant]');
      if (!select) return;

      var item = select.closest('.combo__item');
      if (!item) return;

      var option = select.options[select.selectedIndex];
      var radio = item.querySelector('[data-combo-option]');
      var priceEl = item.querySelector('[data-combo-price]');
      var compareEl = item.querySelector('[data-combo-compare]');

      if (radio) {
        radio.value = option.value;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (priceEl) priceEl.textContent = option.getAttribute('data-combo-price') || priceEl.textContent;
      if (compareEl) compareEl.textContent = option.getAttribute('data-combo-compare') || compareEl.textContent;
    });
  });
})();
